import {Component, Input} from "@angular/core";
import {Facet} from "../../../record/feature-print-models";

@Component({
  selector: 'default-facet',
  templateUrl: './default-facet.component.html',
  styleUrls: ['./default-facet.component.scss']
})
export class DefaultFacetComponent {
  @Input() public facet: Facet | undefined;
  @Input() public previewImageUrl: string | null = null;
}
